export function getManifestUrl(remoteName) {
  return `../${remoteName}/mf-manifest.json`;
}